import React from 'react';
import Layout from '@/components/Documents/common/layout';
import DocsMenu from '@/components/Documents/docs/DocsMenu';
import { withRouter, connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';

@withRouter
class DocsLayout extends React.Component {
  oldPath = null;

  handleApiGroupChange(props) {
    props = props || this.props;
    
    const currentRoute = props.router.currentRoute;

    const apiId = currentRoute.params.docs;
    const groupId = currentRoute.query.groupId;
    const path = currentRoute.path;

    
    if(path === this.oldPath) {
      return;
    }

    this.oldPath = path;

    const defaultOpenKeys = [];
    const defaultSelectedKeys = [];

    if (apiId) {
      defaultSelectedKeys.push(apiId);
    }
    if (groupId) {
      defaultOpenKeys.push(groupId);
    }
    return { path, defaultOpenKeys, defaultSelectedKeys };
  }

  componentWillMount() {
    dispatch.sider.fetch();
  }

  render() {
    const { children, groups = [], groupMap = {}, isLogin, userIsLogin } = this.props;
    const data = this.handleApiGroupChange();
    const result = { groups, groupMap };

    // 检查 login 状态
    if ((isLogin === false && userIsLogin !== true) || userIsLogin === false) { // 只有 false 才是登出
      this.props.router.push('/signIn');
    }

    if (data) {
      const { defaultSelectedKeys, defaultOpenKeys, path } = data;
      result.defaultSelectedKeys = defaultSelectedKeys;
      result.defaultOpenKeys = defaultOpenKeys;
      result.path = path;
    }

    return (
      <Layout tabKey={'docs'}>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <DocsMenu {...result}/>
          <div style={{ minHeight: '62vh', flex: 1, borderLeft: '1px solid #e8e8e8', backgroundColor: '#ffffff', padding: 20 }}>
            {children}
          </div>
        </div>
      </Layout>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const sider = state.sider;
  const user = state.user;
  return {
    groups: sider.groups,
    groupMap: sider.groupMap,
    isLogin: sider.isLogin,
    userIsLogin: user.isLogin
  }
}

export default connect(mapStateToProps)(DocsLayout);
